<nav class="govuk-breadcrumbs" aria-label="Breadcrumb">
  <ol class="govuk-breadcrumbs__list">
    @for(item of items; track $index) {
      <li class="govuk-breadcrumbs__list-item">
        <a class="govuk-breadcrumbs__link" routerLink="{{item.href}}"
         [ngClass]="{'last-child': $index === items.length - 1 }">{{item.text}}</a>
      </li>
    }
  </ol>
</nav>